<div class="aia-wrapper-div">
  @if (isLoading) {
    <aia-cardiogram-loader [overlay]="true" [pulsateBackground]="true"></aia-cardiogram-loader>
  }

  <router-outlet></router-outlet>

  <aia-sidebar-host></aia-sidebar-host>
</div>
